import styled from "styled-components";
import {FilterLinkDefaultBox} from "./filter-link.default.box";
import {ACTIVE} from "../../../../themes/css-global-classes";

export const FilterLinkCasino777Box = styled(FilterLinkDefaultBox)`
  &.${ACTIVE}{
    color: ${props => props.theme.colors.backgroundActive};
  }
`